module.exports = __webpack_public_path__ + "static/media/dario_alineador_960.a04ff99f.jpg";